<!-- Templates -->
<ng-template #success>
    <ng-container *ngIf="{ success: field.success ? (field.success | async) : null }.success as success">
        <span class="success" [innerHTML]="success.slaFormSuccess | matGenericInputLabel"></span>
    </ng-container>
</ng-template>

<ng-template #warn>
    <ng-container *ngIf="{ warn: field.warn ? (field.warn | async) : null }.warn as warn">
        <span class="warn" [innerHTML]="warn.slaFormWarn | matGenericInputLabel"></span>
    </ng-container>
</ng-template>

<ng-template #selected>
    <ng-container
            *ngIf="((control?.statusChanges | async) !== 'INVALID' ? (field.selectSearchData?.selected | async) : null) as data">
        <div class="info selected success" *ngIf="data">
            {{ field.selectSearchData?.selectData | matGenericInputLabel : data : true }}
        </div>
    </ng-container>
</ng-template>

<!-- Hint -->
<ng-container [ngSwitch]="type">

    <ng-container *ngSwitchCase="'error'">
        <ng-container *ngIf="((control?.statusChanges | async) === 'INVALID' ||
                          control.errors) &&
                          control.errors['slaFormError']">
            <span [innerHTML]="control.errors['slaFormError'] | matGenericInputLabel"></span>
        </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'combined'">
        <ng-template [ngTemplateOutlet]="selected"></ng-template>
        <ng-template [ngTemplateOutlet]="success"></ng-template>
        <ng-template [ngTemplateOutlet]="warn"></ng-template>
    </ng-container>

</ng-container>
